import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'collegeTerm'
})
export class CollegeTermPipe implements PipeTransform {
    transform(term : string, extended?: boolean) {
        if (!term) return '';

        switch (term) {
            case '1': return 'Fall' + (extended === true ? ' (Term 1)' : '');
            case '2': return 'Spring' + (extended === true ? ' (Term 2)' : '');
            case '3': return 'Summer' + (extended === true ? ' (Term 3)' : '');
            //case '4': return 'Summer B' + (extended === true ? ' (Term 4)' : '');
            //case 'S': return 'Summer' + (extended === true ? ' (Term S)' : '');
        }

        return term;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/collegeterm.pipe.ts